import React from 'react'
import cn from "classnames";
import { Divider } from "antd";

import styles from "./CreateMultipleTotes.module.sass"
import Modal from '../../../components/Modal';
import CustomToast from '../../../components/CustomToast';
import { DELETE_TOTES_BY_CODES } from '../../../API/Totes';

const DeleteTotes = ({ isModalVisible, handleModalClose, handleSuccess,checkedItems }) => {
    const showToast = CustomToast();

    const handleOnDeleteClick = async () => {
        const selectedItems = Object.keys(checkedItems).filter(
            (id) => checkedItems[id]
          );
        try {
                const response = await DELETE_TOTES_BY_CODES(selectedItems);
                handleSuccess();
                showToast(response.message, "success");
                handleModalClose();
        }catch (error) {
            console.error("Failed to delete totes:", error);
            showToast("error", "Failed to delete totes");
        }
        
    }

    return (
        <>
            <Modal visible={isModalVisible} onClose={handleModalClose}>
                <div className={styles.details}>
                    <div className={cn("title-green", styles.title)}>
                        Confirm Delete
                    </div>
                    <div className={styles.roww}>
                        <div className={styles.coll}>
                            <p className="text-[#6F767E] pt-5">
                                Are you sure you want to delete the selected {checkedItems.length} totes?
                            </p>

                            <Divider />
                            <div className={cn(styles.btns)}>
                                <button
                                    type="button"
                                    className={cn("button-stroke pl-5 pr-5", styles.button)}
                                    onClick={handleModalClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    className={cn("button-clear-stroke button-clear-stroke-red button-small", styles.button)}
                                    onClick={handleOnDeleteClick}
                                >
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default DeleteTotes